import React from 'react';
import { useTranslation } from 'react-i18next';
import { XIcon } from '@phosphor-icons/react';
import { getTranslation } from '../../utils';
import { Spinner } from '../common';
import Button from '../ui/button';

export default function LogoutConfirmation({ onConfirm, onClose, orgPrefix, isLoading = false }) {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-8 relative">
        {/* Close Button */}
        <button
          onClick={onClose}
          disabled={isLoading}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed">
          <XIcon size={24} />
        </button>

        {/* Content */}
        <div className="text-center my-6">
          <h2
            className="text-xl font-bold text-gray-800"
            dangerouslySetInnerHTML={{
              __html: getTranslation(t, 'popups.logout.title', orgPrefix) || 'Logout'
            }}
          />
        </div>

        <div className="text-gray-700 mb-6 text-center leading-relaxed">
          <p
            dangerouslySetInnerHTML={{
              __html:
                getTranslation(t, 'popups.logout.description', orgPrefix) ||
                'Are you sure you want to logout?'
            }}
          />
        </div>

        {/* Action Buttons */}
        <div className="flex gap-4">
          <Button.ButtonRounded onClick={onConfirm} disabled={isLoading} className="flex-1">
            <Spinner isSubmitting={isLoading} />
            {getTranslation(t, 'popups.logout.confirmButton', orgPrefix) || 'Logout'}
          </Button.ButtonRounded>
          <Button.ButtonOutlined handler={onClose} disabled={isLoading} className="flex-1">
            {getTranslation(t, 'popups.logout.cancelButton', orgPrefix) || 'Cancel'}
          </Button.ButtonOutlined>
        </div>
      </div>
    </div>
  );
}
